import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskFormComponent } from './task-form.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ModalFilesModule } from 'src/app/shared/modal-files/modal-files.module';
import { NgxSelectModule } from 'ngx-select-ex';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { CustomSelectOptions } from 'src/app/select-options';
import { CalendarModule } from 'primeng/calendar';
import { ChipsModule } from 'primeng/chips';
import { ModalSettingsModule } from 'src/app/pages/settings/modal-settings/modal-settings.module';
import {InputMaskModule} from 'primeng/inputmask';
import {RadioButtonModule} from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
@NgModule({
  declarations: [
    TaskFormComponent,
  ],
  imports: [
    CommonModule,
    CalendarModule,
    NgbModalModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SweetAlert2Module,
    ModalFilesModule,
    NgxSelectModule.forRoot(CustomSelectOptions),
    WidgetModule,
    ChipsModule,
    ModalSettingsModule,
    InputMaskModule,
    RadioButtonModule,
    OverlayPanelModule
  ],
  exports: [
    TaskFormComponent
  ]
})
export class TaskFormModule { }
